import { render } from "./AttributeTable.vue?vue&type=template&id=fa356fa4"
import script from "./AttributeTable.vue?vue&type=script&lang=js"
export * from "./AttributeTable.vue?vue&type=script&lang=js"

import "./AttributeTable.vue?vue&type=style&index=0&id=fa356fa4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__